import { cn } from '@/shared/lib/utils'

interface CellStatusBadgeProps {
  label: string
  color?: string | null
  className?: string
}

export function CellStatusBadge({ label, color, className }: CellStatusBadgeProps) {
  if (!color) {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium',
          'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
          className
        )}
      >
        {label}
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium',
        className
      )}
      style={{
        backgroundColor: `${color}10`,
        borderColor: `${color}80`,
        color
      }}
    >
      {label}
    </span>
  )
}
